import React from "react";
// import HistoryIcon from "@assets/images/icons/hisoty-ico.svg";
import { BurgerIcon } from "@components/library";
import { useDispatch, useSelector } from "react-redux";
import { AUTH } from "@constants";
import UserProfileDropdown from "@components/layout/Header/components/UserProfileDropdown";
import Mode from "@components/layout/Header/components/Mode";
import "./MobileAuthHeader.sass";

const MobileAuthHeader = ({ sidebarToggle }) => {
  const dispatch = useDispatch();
  const isDemoUser = useSelector((state) => state.auth.isDemoUser);

  const openSidebar = () => {
    sidebarToggle();
  };

  const openAuthPopup = () => {
    dispatch({ type: AUTH.AUTH_CHANGE_POPUP, payload: true });
  };

  return (
    <div className="mobile-header">
      <div className="mobile-header__buttons">
        {/* Рахунок */}
        <div className="header__nav-item">
          <Mode />
        </div>

        {/* Іконка акаунта */}
        {isDemoUser ? (
          <button
            onClick={openAuthPopup}
            type="button"
            className="header__mini-btn"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 15.75V14.25C15 13.4544 14.6839 12.6913 14.1213 12.1287C13.5587 11.5661 12.7956 11.25 12 11.25H6C5.20435 11.25 4.44129 11.5661 3.87868 12.1287C3.31607 12.6913 3 13.4544 3 14.25V15.75"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9 8.25C10.6569 8.25 12 6.90685 12 5.25C12 3.59315 10.6569 2.25 9 2.25C7.34315 2.25 6 3.59315 6 5.25C6 6.90685 7.34315 8.25 9 8.25Z"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        ) : (
          <UserProfileDropdown />
        )}

        {/* Бургер */}
        <button
          className="mobile-header__burger"
          onClick={openSidebar}
          type="button"
        >
          <BurgerIcon />
        </button>
      </div>

      {/*{TRADING_PAGES.includes(location.pathname) ? (*/}
      {/*  <button*/}
      {/*    onClick={() => dispatch({type: BIDS.TOGGLE_HISTORY})}*/}
      {/*    type="button"*/}
      {/*    className={`mobile-header__btn-history${*/}
      {/*      isOpenHistory ? " active" : ""*/}
      {/*    }`}*/}
      {/*  >*/}
      {/*    <TradingHistoryIcon/>*/}
      {/*  </button>*/}
      {/*) : (*/}
      {/*  <Link to={TRADING_HISTORY} className="mobile-header__btn-history">*/}
      {/*    <TradingHistoryIcon/>*/}
      {/*  </Link>*/}
      {/*)}*/}
    </div>
  );
};

export default MobileAuthHeader;
